class o extends window.HTMLElement {
  constructor() {
    ;(super(), this.init())
  }
  init() {
    this.setupToggle()
  }
  setupToggle() {
    const s = this.querySelector('[js-accordion-content-toggle]'),
      t = this.querySelector('[js-accordion-content]'),
      e = s == null ? void 0 : s.querySelector('svg')
    !s ||
      !t ||
      (s.addEventListener('click', i => {
        ;(i.preventDefault(),
          t.classList.contains('is-open')
            ? (t.classList.remove('is-open'),
              (t.style.maxHeight = '0'),
              (t.style.opacity = '0'),
              (t.style.visibility = 'hidden'),
              e == null || e.classList.remove('rotate-180'))
            : (t.classList.add('is-open'),
              (t.style.visibility = 'visible'),
              setTimeout(() => {
                ;((t.style.maxHeight = t.scrollHeight + 'px'),
                  (t.style.opacity = '1'))
              }, 10),
              e == null || e.classList.add('rotate-180')))
      }),
      (t.style.transition =
        'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease, visibility 0.3s ease'),
      (t.style.overflow = 'hidden'),
      (t.style.maxHeight = '0'),
      (t.style.opacity = '0'),
      (t.style.visibility = 'hidden'),
      e && (e.style.transition = 'transform 0.3s ease'))
  }
}
window.customElements.define('product-accordion', o)
export { o as default }
